import { useCallback, useContext, useEffect, useState } from 'react'
import { metodoPrograma } from '../../../../components/api'
import { GlobalContext } from '../../../../App'
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Button,
} from '@mui/material'
import { Eye } from 'lucide-react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import { BsFileMedical } from 'react-icons/bs'

const createAtestado = z.object({
  qtDiasAfastamento: z.string().optional(),
  dtAtestado: z.string().optional(),
})

export const Atestado = ({ atendimentoSelecionado }) => {
  const { agenda } = useContext(GlobalContext)
  const [lista, setLista] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit } = useForm({
    resolver: zodResolver(createAtestado),
    defaultValues: {
      qtDiasAfastamento: undefined,
      dtAtestado: undefined,
    },
  })

  const getListaDocumentos = useCallback(() => {
    metodoPrograma('listaDocumentoPaciente', {
      tpDocumento: 'A',
      idAgenda: agenda[0],
      idPaciente: atendimentoSelecionado.dadosAtendimento[7].idPaciente,
      idAgendamento: atendimentoSelecionado.dadosAtendimento[0],
    }).then((response) => {
      if (response.status) {
        setLista(response.lista)
      }
    })
  }, [agenda, atendimentoSelecionado.dadosAtendimento])

  const salvaAtestado = async (values) => {
    const obj = {
      idAgenda: agenda[0],
      idPaciente: atendimentoSelecionado.dadosAtendimento[7].idPaciente,
      idAgendamento: atendimentoSelecionado.dadosAtendimento[0],
      qtDiasAfastamento:
        values.qtDiasAfastamento !== '' ? values.qtDiasAfastamento : undefined,
      dtAtestado: values.dtAtestado
        ? dayjs(values.dtAtestado).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }
    setLoading(true)
    const result = await metodoPrograma('salvaAtestadoPaciente', obj)
    if (result.status) {
      setOpenModal(false)
      window.open(result.urlDocumentoAssinado)
      getListaDocumentos()
    }
    setLoading(false)
  }

  useEffect(() => {
    getListaDocumentos()
  }, [getListaDocumentos])

  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        <Grid item xs={9}></Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => setOpenModal(true)}
          >
            <BsFileMedical
              style={{
                fontSize: '20px',
                marginBottom: 5,
                marginTop: 5,
                marginRight: 20,
              }}
            />
            Novo Atestado
          </Button>
        </Grid>
      </Grid>
      {lista?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tipo</TableCell>
              <TableCell>Data</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {lista.map((item) => (
              <TableRow key={item[0]}>
                <TableCell>{item[1]}</TableCell>
                <TableCell>{item[2]}</TableCell>
                <TableCell>
                  <div className="flex gap-3 justify-end">
                    {item[3] && (
                      <IconButton
                        size="small"
                        onClick={() => window.open(item[3])}
                      >
                        <Eye size={18} />
                      </IconButton>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '14px 16px',
            borderRadius: 10,
            backgroundColor: '#f6f8fa',
            border: '1px solid #e5e7eb',
            color: '#6b7280',
          }}
        >
          <div
            style={{
              fontSize: 20,
              lineHeight: 1,
            }}
          >
            📄
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 14, fontWeight: 500 }}>
              Nenhum atestado encontrado
            </span>

            <span style={{ fontSize: 12, color: '#9ca3af' }}>
              Ainda não existem atestados cadastrados para este paciente.
            </span>
          </div>
        </div>
      )}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Atestado</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(salvaAtestado)}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  {...register('qtDiasAfastamento')}
                  label="Dias de Afastamento"
                  fullWidth
                  type="number"
                  margin="dense"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register('dtAtestado')}
                  label="Data do Atestado"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'right' }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} /> : null}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}
